import React from 'react';
import { Modal } from '../../Modal';

export const StakeNftSuccessModal = ({ openedModal, handleCloseModal }) => {
  const now = new Date();

  const nextWeekStart = new Date(now);
  const daysUntilNextMonday = (7 - now.getDay() + 1) % 7 || 7;
  nextWeekStart.setDate(now.getDate() + daysUntilNextMonday);

  const nextWeekEnd = new Date(nextWeekStart);
  nextWeekEnd.setDate(nextWeekStart.getDate() + 6);

  const startDate = nextWeekStart.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
  });
  const endDate = nextWeekEnd.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
  });

  return (
    <Modal className="!mb-[0rem]" isOpened={openedModal} onClose={handleCloseModal}>
      <div className="w-[48rem] h-[45rem] !relative flex flex-col items-center justify-between space-y-2 p-[4rem] rounded-[3rem] border-[0.1rem] border-solid border-white-50 bg-white-50 bg-blend-difference shadow-[0px_20px_50px_0px_rgba(0,0,0,0.40)] backdrop-blur-[5rem] lg:w-full lg:items-center lg:px-[2rem] lg:rounded-none lg:rounded-t-[2rem] lg:space-y-[2.4rem] lg:h-full lg:border-none">
        <span className="text-[3.2rem] text-white font-600 mb-2 tracking-[-0.64px] lg:text-[2.4rem] lg:tracking-[-0.48px]">
          <span className="text-white-500">Your</span> NFTs are staked
        </span>
        <img className="w-fit h-[20rem] object-fit" src="/images/dashboard/nftsBanner.webp"></img>
        <div className="flex flex-col justify-center items-center space-y-5">
          <span className="text-[1.6rem] font-600 leading-normal text-white-500 text-center max-w-[43rem]">
            Rewards period <br /> starts on <span className="text-white">{startDate}</span> and ends on{' '}
            <span className="text-white font-700">{endDate}</span>
          </span>
          <div className="bg-white-100 p-2 rounded-[1rem] text-[1.6rem] font-600 leading-normal text-white-500 text-center max-w-[43rem]">
            You can see NFTs on <span className="text-white font-700">Next stake</span> tab
          </div>
        </div>
      </div>
    </Modal>
  );
};
